import React, { useEffect, useRef, useState } from 'react'
import { useUser } from '../../utils/userContext';
import useHandleErrors from '../../utils/user.utils';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import useConfiguration from '../../utils/ConfigurationContext';

const Complaint = () => {
    const { user } = useUser();
    const [showModal, setShowModal] = useState(false);
    const [file, setFile] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fileData, setFileData] = useState([]);
    const [employees, setEmployees] = useState([]);
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);
    const config = useConfiguration();
    const [formData, setFormData] = useState({
        suggestion: "",
        description: "",
        mail: ""
    });
    const handleErrors = useHandleErrors();

    const handleCloseModal = () => {
        setShowModal(false);

    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = () => {
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const binaryData = e.target.result;
                setUploadedFiles((prevFiles) => [...prevFiles, file]);
                setFileData((prevData) => [...prevData, binaryData]);
                setFile(null);
            };
            reader.readAsBinaryString(file);
        }
    };

    const handleDelete = (fileIndex) => {
        setUploadedFiles((prevFiles) => prevFiles.filter((_, index) => index !== fileIndex));
        setFileData((prevData) => prevData.filter((_, index) => index !== fileIndex));
    };
    const handleCancel = (e) => {
        e.preventDefault();
        setFormData({
            suggestion: "",
            description: "",
        })
        setUploadedFiles([])
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const token = localStorage.getItem("token");
        if (!formData.mail) {
            toast.error("Email is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.description) {
            toast.error("Description is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!uploadedFiles || uploadedFiles.length === 0) {
            toast.error("Document is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.suggestion) {
            toast.error("Suggestion is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }

        const data = new FormData();
        uploadedFiles.forEach((file, index) => {
            data.append('feedBackDocument', new Blob([fileData[index]], { type: file.type }), file.name);
        });
        data.append('employeeID', user?.EmployeeId);
        data.append('employeeEmail', user?.OfficialEmail);
        data.append('employeeName', user?.FirstName + " " + user?.LastName);
        Object.keys(formData).forEach((key) => {
            data.append(key, formData[key]);
        });

        try {
            const path = "/complaintAndFeedback";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 200) {
                setShowModal(true)
                setFormData({
                    suggestion: "",
                    description: "",
                })
                setUploadedFiles([])
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const fetchEmployess = async () => {
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                setEmployees(response.data.onboardEmployeeDetails);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchEmployess();
            hasFetchedRef.current = true;
        }
    }, []);

    const employeeOptions = employees.map((emp) => ({
        value: emp.OfficialEmail,
        label: `${emp.OfficialEmail}`,
    }));

    const ClearIndicator = () => null;



    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Complaint and Feedback</h3>
                        </div>
                        <div class="col-auto">
                            <a href={'/Payslips'} data-extra-toggle="tab" data-target="#self-service-pan" class="btn btn-primary mt-lg-0 mt-4"><i class="ri-fingerprint-line"></i> Self-Service</a>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-8">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label class="mt-2">Employee ID</label>
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control-plaintext" value={user?.EmployeeId} readonly />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label class="mt-2">Employee Name</label>
                                        </div>
                                        <div class="col">
                                            <input type="text" class="form-control-plaintext" value={user?.FirstName + " " + user?.LastName} readonly />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label class="mt-2">Employee Email</label>
                                        </div>
                                        <div class="col">
                                            <input type="email" class="form-control-plaintext" value={user?.OfficialEmail} readonly />
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6">
                                            <div class="form-group">
                                                <label for="mail" class="required">Request to Email</label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    name="mail"
                                                    value={
                                                        employeeOptions.find(
                                                            (option) => option.value === formData.mail
                                                        ) || null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        setFormData({
                                                            ...formData,
                                                            mail: selectedOption ? selectedOption.value : "",
                                                        })
                                                    }
                                                    options={employeeOptions}
                                                    components={{ ClearIndicator }}
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        control: base => ({ ...base, zIndex: 1 })
                                                      }}
                                                />
                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12">
                                            <div class="form-group">
                                                <label for="description" class="required">Description</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="4"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="Document" className="required">
                                                    Document
                                                </label>
                                                <div className="d-flex align-items-center">
                                                    <div className="custom-file mr-2">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id="Document"
                                                            onChange={handleFileChange}
                                                        />
                                                        <label className="custom-file-label" htmlFor="uploadEmpofferletter">
                                                            {file ? file.name : 'Choose a file'}
                                                        </label>
                                                    </div>
                                                    <button className="btn btn-secondary" onClick={handleUpload}>
                                                        Upload
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="container-fluid my-2 px-0">
                                                <div className="row">
                                                    {uploadedFiles?.map((file, index) => (
                                                        <div key={index} className="col-6 mb-2">
                                                            <button
                                                                className="btn btn-link text-danger btn-action"
                                                                type="button"
                                                                onClick={() => handleDelete(index)}
                                                            >
                                                                <i className="ri-delete-bin-6-line" />
                                                            </button>
                                                            <a href="#" onClick={() => window.open(URL.createObjectURL(file), '_blank')}>
                                                                {file.name}
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12">
                                            <div class="form-group">
                                                <label for="suggestion" class="required">Suggestion</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="4"
                                                    name="suggestion"
                                                    value={formData.suggestion}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="card ww-app-bg">
                                <div class="card-body ">
                                    <span><i class="ri-draft-fill"></i></span>
                                </div>
                            </div>
                            <div class="card mb-4">
                                <div class="card-body">
                                    <h4 class="mb-2">Know about policies?</h4>
                                    <p>Click the below icon and refer all our policies related to your needs.</p>
                                    <div class="row align-items-center justify-content-center">
                                        <div class="col-auto text-center">
                                            <a href={"/policies"} class="info-icon-box" title="Policies" rel="tooltip"><i class="ri-file-text-line"></i></a>
                                        </div>
                                    </div>

                                    <div class="row align-items-center border-top">
                                        <div class="col-12">
                                            <p class="mt-3">Quickly get in touch with us for more queries.</p>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-1"><i class="ri-mail-send-fill"></i></div>
                                        <div class="col">{config?.adminEmail}</div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-1"><i class="ri-message-3-line"></i></div>
                                        <div class="col">Chat with us</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row fixed-footer">
                <div className="col-lg-12 text-center">
                    <button type="reset" className="btn btn-light" onClick={handleCancel}>Clear</button>
                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Submit <i className="ri-checkbox-circle-line"></i></button>
                </div>
            </div>
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                                    <div className="col-12 text-center">Complaint Submitted Successfully.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Complaint;
